var render = function render(){var _vm=this,_c=_vm._self._c;return _c('TermsLayout',[_c('div',{staticClass:"flex-wrap"},[_c('ContentsTable',{attrs:{"items":_vm.items,"textRef":_vm.$refs.text}}),_c('div',[_c('TermsTitle',{attrs:{"title":_vm.title,"subtitle":_vm.subtitle}}),_c('div',{ref:"text",domProps:{"innerHTML":_vm._s(_vm.text)}})],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }